<div class="placement-page core-screen">
  @if (loadingWarehouse()) {
  <div class="state-message">{{ 'common.loading' | translate }}</div>
  } @else if (warehouseError(); as err) {
  <div class="state-message state-message--error">{{ err }}</div>
  } @else {
  <div class="placement-content">
    @if (!embeddedInCabinetPage()) {
    <h2 class="title">{{ warehouseName() }}</h2>
    }
    <p class="lead">{{ 'admin.warehouses.placement.lead' | translate }}</p>

    @if (!hasWarehouseGrid()) {
    <div class="state-message state-message--warn">
      {{ 'admin.warehouses.placement.noGridConfig' | translate }}
    </div>
    }

    <lib-not-button
      [text]="'admin.warehouses.placement.scanQr' | translate"
      [color]="'#140342'"
      [bgColor]="'#E8F9F7'"
      [disabled]="scanning()"
      [action]="{ type: 'action' }"
      (actionEvent)="onScanQr()"
    />

    @if (loadingTarget()) {
    <div class="state-message">{{ 'common.loading' | translate }}</div>
    } @else if (target(); as t) {
    <div class="entity-card">
      @if (t.kind === 'box') {
      <div class="entity-card__title">
        {{ 'admin.warehouses.placement.boxHint' | translate }}
      </div>
      <div class="entity-card__row">
        <span class="label">{{ 'admin.warehouses.placement.boxIdShort' | translate }}</span>
        <span class="mono">{{ t.entity.id }}</span>
      </div>
      } @else {
      <div class="entity-card__title">
        {{ 'admin.warehouses.placement.itemHint' | translate }}
      </div>
      <div class="entity-card__row">
        <span class="label">{{ 'admin.warehouses.placement.itemName' | translate }}</span>
        <span>{{ t.entity.name }}</span>
      </div>
      <div class="entity-card__row">
        <span class="label">{{ 'admin.warehouses.placement.boxIdShort' | translate }}</span>
        <span class="mono">{{ t.entity.id }}</span>
      </div>
      }
      <div class="entity-card__row">
        <span class="label">{{ 'admin.warehouses.placement.statusLabel' | translate }}</span>
        <span>{{ t.entity.status }}</span>
      </div>
      @if (targetAddressLabel(); as addr) {
      <div class="entity-card__row">
        <span class="label">{{ 'admin.warehouses.placement.currentAddress' | translate }}</span>
        <span>{{ addr }}</span>
      </div>
      }
    </div>
    }

    <lib-staff-warehouse-cell-picker
      [warehouseId]="warehouseId()"
      [initialCells]="pickerInitialCells()"
      [submitting]="submitting()"
      [disabled]="!target() || loadingTarget()"
      (submitCells)="onPickerSubmit($event)"
    />
  </div>
  }
</div>
